import * as React from 'react';
import { useNavigate } from "react-router-dom";

import { LineChart } from '@mui/x-charts/LineChart';

const worldElectricityProduction = [
    {
        year: 1985,
        division1: 1488.9216,
        division2: 1110.7847,
        division3: 1426.3086,
        division4: 3748.3848,
    },
    {
        year: 1986,
        division1: 1594.7357,
        division2: 1168.3097,
        division3: 1432.6683,
        division4: 3839.0095,
    },
    {
        year: 1987,
        division1: 1734.7332,
        division2: 1183.1947,
        division3: 1516.4941,
        division4: 4058.0767,
    },
    {
        year: 1988,
        division1: 1891.2493,
        division2: 1256.5684,
        division3: 1540.9414,
        division4: 4200.6743,
    },
    {
        year: 1989,
        division1: 1945.0106,
        division2: 1350.2358,
        division3: 1728.5189,
        division4: 4376.982,
    },
    {
        year: 1990,
        division1: 2000.596,
        division2: 1364.6844,
        division3: 1789.7031,
        division4: 4460.2417,
    },
    {
        year: 1991,
        division1: 2096.3098,
        division2: 1349.9071,
        division3: 1815.2444,
        division4: 4557.0664,
    },
    {
        year: 1992,
        division1: 2112.223,
        division2: 1328.2163,
        division3: 1829.3868,
        division4: 4649.9165,
    },
    {
        year: 1993,
        division1: 2184.9646,
        division2: 1266.6155,
        division3: 1863.8153,
        division4: 4727.899,
    },
    {
        year: 1994,
        division1: 2225.9788,
        division2: 1302.1187,
        division3: 1925.1002,
        division4: 4891.904,
    },
    {
        year: 1995,
        division1: 2322.5298,
        division2: 1259.9452,
        division3: 2036.3821,
        division4: 5038.9316,
    },
    {
        year: 1996,
        division1: 2406.615,
        division2: 1245.6957,
        division3: 2101.594,
        division4: 5279.661,
    },
    {
        year: 1997,
        division1: 2390.0642,
        division2: 1244.647,
        division3: 2271.0615,
        division4: 5395.626,
    },
    {
        year: 1998,
        division1: 2431.1948,
        division2: 1294.6146,
        division3: 2408.5476,
        division4: 5511.2935,
    },
    {
        year: 1999,
        division1: 2523.7056,
        division2: 1266.6599,
        division3: 2600.75,
        division4: 5630.859,
    },
    {
        year: 2000,
        division1: 2507.43,
        division2: 1209.51,
        division3: 2681.11,
        division4: 5719.12,
    },
    {
        year: 2001,
        division1: 2573.71,
        division2: 1197.6,
        division3: 2827.65,
        division4: 5801.14,
    },
    {
        year: 2002,
        division1: 2601.89,
        division2: 1175.58,
        division3: 3033.78,
        division4: 6056.12,
    },
    {
        year: 2003,
        division1: 2577.71,
        division2: 1198.2,
        division3: 3165.78,
        division4: 6458.61,
    },
    {
        year: 2004,
        division1: 2682.73,
        division2: 1177.47,
        division3: 3408.19,
        division4: 6697.61,
    },
    {
        year: 2005,
        division1: 2686.95,
        division2: 1186.13,
        division3: 3579.99,
        division4: 7040.85,
    },
    {
        year: 2006,
        division1: 2721.42,
        division2: 1097.06,
        division3: 3792.38,
        division4: 7439.88,
    },
    {
        year: 2007,
        division1: 2666.92,
        division2: 1119.39,
        division3: 4109.47,
        division4: 7931.82,
    },
    {
        year: 2008,
        division1: 2656.04,
        division2: 1078.99,
        division3: 4210.51,
        division4: 7927.59,
    },
    {
        year: 2009,
        division1: 2619,
        division2: 1005.12,
        division3: 4247.72,
        division4: 7817.32,
    },
    {
        year: 2010,
        division1: 2686.44,
        division2: 1011.78,
        division3: 4701.27,
        division4: 8358.6,
    },
    {
        year: 2011,
        division1: 2575.35,
        division2: 1103.87,
        division3: 4767.24,
        division4: 8814.17,
    },
    {
        year: 2012,
        division1: 2403.21,
        division2: 1157.13,
        division3: 5042.66,
        division4: 8855.83,
    },
    {
        year: 2013,
        division1: 2418.44,
        division2: 1118.61,
        division3: 4939.52,
        division4: 9306.75,
    },
    {
        year: 2014,
        division1: 2472.7,
        division2: 1063.74,
        division3: 5096.07,
        division4: 9495.57,
    },
    {
        year: 2015,
        division1: 2502.45,
        division2: 1068.09,
        division3: 5418.55,
        division4: 9160.63,
    },
    {
        year: 2016,
        division1: 2540.48,
        division2: 1004.96,
        division3: 5669.08,
        division4: 9226.85,
    },
    {
        year: 2017,
        division1: 2566.22,
        division2: 913.07,
        division3: 5791.83,
        division4: 9518.91,
    },
    {
        year: 2018,
        division1: 2619.57,
        division2: 841.34,
        division3: 6015.24,
        division4: 9899.44,
    },
    {
        year: 2019,
        division1: 2724.08,
        division2: 776.78,
        division3: 6176.34,
        division4: 9680.92,
    },
    {
        year: 2020,
        division1: 2634.69,
        division2: 741,
        division3: 6132.47,
        division4: 9292.9,
    },
    {
        year: 2021,
        division1: 2740.78,
        division2: 793.53,
        division3: 6326,
        division4: 10081.8,
    },
    {
        year: 2022,
        division1: 2610.04,
        division2: 884.98,
        division3: 6309.46,
        division4: 10190.71,
    },
];

const keyToLabel = {
    division4: 'Division 4 (Ton)',
    division3: 'Division 3 (Ton)',
    division2: 'Division 2 (Ton)',
    division1: 'Division 1 (Ton)',
};

const colors = {
    division1: 'orange',
    division2: 'darkgrey',
    division3: 'gray',
    division4: 'black',
};

const customize = {
    height: 300,
    legend: { hidden: true },
    margin: { top: 5 },
    stackingOrder: 'descending',
};

export default function LineDataset() {
    let navigate = useNavigate();
    return (
        <LineChart
            xAxis={[
                {
                    dataKey: 'year',
                    valueFormatter: (value) => value.toString(),
                    min: 1985,
                    max: 2022,
                },
            ]}
            series={Object.keys(keyToLabel).map((key) => ({
                dataKey: key,
                label: keyToLabel[key],
                showMark: false,

            }))}
            dataset={worldElectricityProduction}
            {...customize}
            onLineClick={(event, d) => navigate("/farm-division")}
            onAxisClick={(event, d) => navigate("/farm-division")}
        />
    );
}
